/* lenz-google-reviews.js — reemplazo propio del widget de Reputon.
 *
 * Lee el snapshot inyectado por Liquid (metafield de shop
 * lenz.google_reviews, <script type="application/json">) y construye el
 * bloque completo: mapa (imagen estática de la zona con el pin, asset del
 * tema generado una sola vez — hasta 2026-10-24 era el iframe de Google
 * Maps Embed, ~466 KB por visita y con una tarjeta que repetía la ficha),
 * ficha del negocio y carrusel de reseñas con scroll-snap.
 *
 * CERO dependencias runtime: el mapa es un <img> propio enlazado a "cómo
 * llegar"; si el JSON falta, el fallback estático del Liquid sigue visible.
 * El mismo archivo se usa en el harness de test local (tools/) — cualquier
 * cambio acá se prueba ahí ANTES de tocar el home.
 */
(function () {
  'use strict';

  var host = document.querySelector('[data-lenz-gr]');
  var dataEl = document.getElementById('lenz-gr-data');
  if (!host || !dataEl) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var biz = data && data.business;
  if (!biz || !biz.name) return;

  var esc = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };

  // ── SVG helpers ─────────────────────────────────────────────────────────
  var STAR = 'M12 2l2.9 6.26 6.87.6-5.2 4.55L18.1 20 12 16.4 5.9 20l1.53-6.59-5.2-4.55 6.87-.6z';
  function starsHtml(rating) {
    var out = '<span class="lenz-gr__stars" aria-label="' + esc(rating) + ' de 5">';
    for (var i = 1; i <= 5; i++) {
      var fill = rating >= i - 0.25 ? 'st-full' : rating >= i - 0.75 ? 'st-half' : 'st-empty';
      if (fill === 'st-half') {
        // media estrella: base gris + mitad ámbar con clip
        out += '<svg viewBox="0 0 24 24"><path class="st-half-base" d="' + STAR + '"/>' +
          '<clipPath id="lgr-h' + i + '"><rect x="0" y="0" width="12" height="24"/></clipPath>' +
          '<path class="st-full" clip-path="url(#lgr-h' + i + ')" d="' + STAR + '"/></svg>';
      } else {
        out += '<svg viewBox="0 0 24 24"><path class="' + fill + '" d="' + STAR + '"/></svg>';
      }
    }
    return out + '</span>';
  }
  var G_LOGO = '<svg class="lenz-gr__glogo" viewBox="0 0 24 24"><path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.1h6.5c-.1 1.1-.8 2.7-2.4 3.8l3.7 2.8c2.2-2 3.7-5 3.7-8.5z"/><path fill="#34A853" d="M12 24c3.2 0 5.9-1.1 7.9-2.9l-3.7-2.8c-1 .7-2.4 1.2-4.2 1.2-3.2 0-5.9-2.1-6.9-5L1.3 17.4C3.3 21.3 7.3 24 12 24z"/><path fill="#FBBC05" d="M5.1 14.5c-.2-.7-.4-1.5-.4-2.5s.2-1.8.4-2.5L1.3 6.6C.5 8.3 0 10.1 0 12s.5 3.7 1.3 5.4l3.8-2.9z"/><path fill="#EA4335" d="M12 4.5c2.3 0 3.8 1 4.7 1.8l3.4-3.3C18 1.1 15.2 0 12 0 7.3 0 3.3 2.7 1.3 6.6l3.8 2.9c1-2.9 3.7-5 6.9-5z"/></svg>';
  var PIN = '<svg viewBox="0 0 24 24"><path d="M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>';
  var PHONE = '<svg viewBox="0 0 24 24"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1l-2.3 2.2z"/></svg>';
  var CLOCK = '<svg viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm.5 5H11v6l5.2 3.1.8-1.2-4.5-2.7V7z"/></svg>';

  // ── Columna mapa + ficha ────────────────────────────────────────────────
  // Imagen fija del mapa (data-map-src la pone el Liquid con asset_url;
  // assets/lenz-mapa-lince.png, Static Maps generado una vez, zoom 16, pin
  // en la tienda). Sin iframe: la ficha de al lado ya trae nombre, nota,
  // teléfono, dirección y horario; el mapa solo ubica y lleva a "cómo llegar".
  var mapsHref = biz.url || ('https://www.google.com/maps/search/?api=1&query=' +
    encodeURIComponent(biz.name) + '&query_place_id=' + encodeURIComponent(biz.placeId || ''));
  var dirHref = 'https://www.google.com/maps/dir/?api=1&destination=' +
    encodeURIComponent(biz.name + ', ' + biz.address) +
    (biz.placeId ? '&destination_place_id=' + encodeURIComponent(biz.placeId) : '');
  var mapSrc = host.getAttribute('data-map-src') || '';
  // data-map-mode="embed" (setting de la sección; lo usa el home a pedido del
  // dueño, 25-oct): vuelve el iframe gratuito de Google Maps, que trae su propia
  // ficha (nombre, dirección, nota, "Abrir en Maps"); por eso ahí la ficha
  // propia se oculta (data-show-biz="0") para no repetir la información.
  var embed = host.getAttribute('data-map-mode') === 'embed';
  var showBiz = host.getAttribute('data-show-biz') !== '0';
  var mapCol = embed
    ? '<div class="lenz-gr__map">' +
        // q por nombre+dirección: el Embed gratuito no resuelve q=place_id.
        '<iframe class="lenz-gr__map-frame" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ' +
          'title="Mapa: ' + esc(biz.name) + '" ' +
          'src="https://maps.google.com/maps?q=' + encodeURIComponent(biz.name + ', ' + biz.address) + '&z=16&output=embed&hl=es"></iframe>' +
      '</div>'
    :
    '<a class="lenz-gr__map" href="' + esc(dirHref) + '" target="_blank" rel="noopener">' +
      (mapSrc
        ? '<img class="lenz-gr__map-img" src="' + esc(mapSrc) + '" width="1280" height="1280" loading="lazy" decoding="async" ' +
            'alt="Mapa de la zona: ' + esc(biz.name) + ', ' + esc(biz.address) + '">'
        : '') +
      '<span class="lenz-gr__map-cta">' + PIN + 'Cómo llegar</span>' +
    '</a>';
  // Ficha del negocio: va ARRIBA de las reseñas, en la columna derecha. Antes
  // iba debajo del mapa y quedaba sola (viuda) bajo el carrusel, más corto.
  // Horario de la tienda (data-hours, del Liquid) manda sobre el del perfil de
  // Google: el perfil decía L-V 9:00 y la tienda abre a las 10:00 (dueño, 25-oct).
  var fixedHours = (host.getAttribute('data-hours') || '').split('|').filter(Boolean);
  var hoursList = fixedHours.length ? fixedHours
    : (biz.openHours && biz.openHours.length ? hoursLines(biz.openHours) : []);
  var bizHtml = !showBiz ? '' :
      '<div class="lenz-gr__biz">' +
        '<h3 class="lenz-gr__biz-name">' + esc(biz.name) + '</h3>' +
        '<div class="lenz-gr__rating-row">' +
          '<span class="lenz-gr__rating-num">' + esc(biz.rating) + '</span>' +
          starsHtml(Number(biz.rating) || 0) +
          '<span class="lenz-gr__count"><a href="' + esc(mapsHref) + '" target="_blank" rel="noopener">' +
            esc(biz.reviewsNumber) + ' reseñas</a></span>' +
        '</div>' +
        '<ul class="lenz-gr__meta">' +
          (biz.phone ? '<li>' + PHONE + '<a href="tel:' + esc(biz.phone) + '">' + esc(fmtPhone(biz.phone)) + '</a></li>' : '') +
          '<li>' + PIN + esc(biz.address) + '</li>' +
          (hoursList.length
            ? '<li>' + CLOCK + '<span class="lenz-gr__hours">' + hoursList.map(esc).join('<br>') + '</span></li>' : '') +
        '</ul>' +
        '<a class="lenz-gr__open-maps" href="' + esc(mapsHref) + '" target="_blank" rel="noopener">Abrir en Google Maps ↗</a>' +
      '</div>';

  // "+51905448520" (snapshot) → "905 448 520"; otro formato se muestra tal cual.
  function fmtPhone(p) {
    var m = /^\+?51(\d{3})(\d{3})(\d{3})$/.exec(String(p).replace(/\s+/g, ''));
    return m ? m[1] + ' ' + m[2] + ' ' + m[3] : String(p);
  }

  function hoursLines(hours) {
    // openHours viene como lista "lunes: 9:00–18:00" … "domingo: Cerrado"
    // (formato Google, lunes primero). Se muestra la semana completa
    // agrupando días consecutivos con el mismo horario:
    // "Lunes a viernes: 9:00–18:00" / "Sábado: 10:00–14:00" / "Domingo: cerrado".
    // Hasta 2026-10-24 solo se veía el día actual.
    var cap = function (d) { return d.charAt(0).toUpperCase() + d.slice(1); };
    var groups = [];
    for (var i = 0; i < hours.length; i++) {
      var m = /^([^:]+):\s*(.+)$/.exec(String(hours[i]));
      if (!m) return hours.map(String); // formato desconocido: tal cual
      var day = m[1].trim().toLowerCase(), val = m[2].trim();
      var last = groups[groups.length - 1];
      if (last && last.val === val) last.to = day; else groups.push({ from: day, to: day, val: val });
    }
    return groups.map(function (g) {
      return (g.from === g.to ? cap(g.from) : cap(g.from) + ' a ' + g.to) + ': ' + g.val.toLowerCase();
    });
  }

  // "Hace 3 semanas" calculado en el navegador desde r.time (segundos epoch).
  // El r.when del snapshot queda congelado el día del refresh; si el cron
  // deja de correr, la fecha relativa igual sigue siendo cierta.
  function relTime(r) {
    var t = Number(r.time);
    if (!t || !window.Intl || !Intl.RelativeTimeFormat) return r.when || '';
    var secs = Date.now() / 1000 - t;
    var units = [[31536000, 'year'], [2592000, 'month'], [604800, 'week'], [86400, 'day']];
    for (var i = 0; i < units.length; i++) {
      if (secs >= units[i][0]) {
        var s = new Intl.RelativeTimeFormat('es', { numeric: 'always' }).format(-Math.floor(secs / units[i][0]), units[i][1]);
        return s.charAt(0).toUpperCase() + s.slice(1);
      }
    }
    return 'Hoy';
  }

  // ── Carrusel de reseñas ─────────────────────────────────────────────────
  var cards = (data.reviews || []).map(function (r, i) {
    var avatar = r.avatar
      ? '<img class="lenz-gr__avatar" loading="lazy" referrerpolicy="no-referrer" src="' + esc(r.avatar) + '" alt="" onerror="this.style.visibility=\'hidden\'">'
      : '<span class="lenz-gr__avatar"></span>';
    var author = r.authorUrl
      ? '<a href="' + esc(r.authorUrl) + '" target="_blank" rel="noopener">' + esc(r.author) + '</a>'
      : esc(r.author);
    // La fuente pasó a entregar cada imagen como {url, thumbnailUrl} (antes
    // era un string): usarla tal cual pintaba src="[object Object]" y cada
    // visita bajaba un 404 de ~276 KB. Se aceptan ambos formatos.
    var img0 = r.images && r.images[0];
    var photoSrc = img0 && (typeof img0 === 'string' ? img0 : (img0.thumbnailUrl || img0.url));
    var photo = (typeof photoSrc === 'string' && photoSrc)
      ? '<img class="lenz-gr__photo" loading="lazy" referrerpolicy="no-referrer" src="' + esc(photoSrc) + '" alt="Foto de la reseña" onerror="this.remove()">'
      : '';
    return '<article class="lenz-gr__card" data-i="' + i + '">' +
      '<div class="lenz-gr__card-head">' + avatar +
        '<div style="min-width:0">' +
          '<div class="lenz-gr__author">' + author + '</div>' +
          '<div class="lenz-gr__when">' + esc(relTime(r)) + '</div>' +
        '</div>' + G_LOGO +
      '</div>' +
      '<div class="lenz-gr__card-stars">' + starsHtml(r.rating) + '</div>' +
      '<div class="lenz-gr__card-body">' +
        '<p class="lenz-gr__text">' + esc(r.text) + '</p>' + photo +
      '</div>' +
      '<button class="lenz-gr__more" type="button" hidden>Mostrar más</button>' +
    '</article>';
  }).join('');

  var revCol =
    '<div class="lenz-gr__side">' + bizHtml +
    '<div class="lenz-gr__carousel">' +
      '<div class="lenz-gr__track" tabindex="0" aria-label="Reseñas de Google">' + cards + '</div>' +
      '<div class="lenz-gr__nav">' +
        '<button class="lenz-gr__arrow" type="button" data-dir="-1" aria-label="Anterior"><svg viewBox="0 0 24 24"><path d="M15.4 7.4 14 6l-6 6 6 6 1.4-1.4L10.8 12z"/></svg></button>' +
        '<button class="lenz-gr__arrow" type="button" data-dir="1" aria-label="Siguiente"><svg viewBox="0 0 24 24"><path d="m8.6 16.6 1.4 1.4 6-6-6-6-1.4 1.4 4.6 4.6z"/></svg></button>' +
      '</div>' +
      (biz.writeReviewUrl
        ? '<a class="lenz-gr__write" href="' + esc(biz.writeReviewUrl) + '" target="_blank" rel="noopener">✏️ Escribir una reseña</a>'
        : '') +
    '</div>' +
    '</div>';

  host.innerHTML = '<div class="lenz-gr">' + mapCol + revCol + '</div>';
  host.dispatchEvent(new CustomEvent('lenz:gr-ready', { bubbles: true }));

  // "Mostrar más" solo cuando el texto realmente está clampeado
  host.querySelectorAll('.lenz-gr__card').forEach(function (card) {
    var p = card.querySelector('.lenz-gr__text');
    var btn = card.querySelector('.lenz-gr__more');
    if (p.scrollHeight > p.clientHeight + 2) btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = card.classList.toggle('is-open');
      btn.textContent = open ? 'Mostrar menos' : 'Mostrar más';
    });
  });

  // Flechas: avanzan de a un card (ancho + gap)
  var track = host.querySelector('.lenz-gr__track');
  host.querySelectorAll('.lenz-gr__arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = track.querySelector('.lenz-gr__card');
      var step = card ? card.getBoundingClientRect().width + 16 : 280;
      track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
    });
  });
})();
